import { render, staticRenderFns } from "./EditForm.vue?vue&type=template&id=0c823e6f&scoped=true"
import script from "./EditForm.vue?vue&type=script&lang=ts"
export * from "./EditForm.vue?vue&type=script&lang=ts"
import style0 from "./EditForm.vue?vue&type=style&index=0&id=0c823e6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c823e6f",
  null
  
)

export default component.exports